/* eslint-disable import/no-unresolved */

import { useDevice } from 'hooks/useResponsive';

import PanIndiaRoadSectionMobile from './PanIndiaRoadSectionMobile';
import PanIndiaRoadSectionWeb from './PanIndiaRoadSectionWeb';

export default function PanIndiaSection() {
  const { isMobile } = useDevice();

  return <div>{isMobile ? <PanIndiaRoadSectionMobile /> : <PanIndiaRoadSectionWeb />}</div>;
}
